import { tmsProductData } from './tms-products';
export const homeDecor = {
    idea1: {
        "title": "Home decor ideas ",
        "subTitle": "",
        "image": "/assets/img/thumbnails/home-decor-1.png",
        "url": "/top-laptops-under-20k",
        "date": "",
        "tags": [
            "Home Decor"
        ],
        "categories": [
            "Home improvement"
        ],
        "recommendations": "Home decor recommendations",
        "pageStructure": [
            {
                "component": "paragraphBoldItalic",
                "text": "Transform your home into a stylish and inviting space with simple yet impactful decor upgrades! **Add personality with wall decor** by incorporating statement art pieces, gallery walls, or elegant mirrors to reflect your unique style."
            },
            {
                "component": "paragraphBoldItalic",
                "text": "**Upgrade your lighting** with chic pendant lights, warm floor lamps, or trendy LED accents to create the perfect ambiance. Incorporate affordable textiles like cozy throw pillows, patterned rugs, and soft curtains to instantly refresh any room. Use **indoor plants** and greenery to bring a touch of nature indoors, adding vibrancy and freshness to your space. "
            },
            {
                "component": "paragraphBoldItalic",
                "text": "Finally, **enhance with decorative accessories** such as vases, candles, and stylish trays to tie everything together. Small changes can make a big difference—get creative and give your home a fresh, new look!"
            },
            {
                "component": "multiProductList",
                "paragraphs": [
                    "Use wall art, decals, or photo frames to add character to empty walls.",
                    "Opt for peel - and - stick wallpapers for a quick and temporary makeover."
                ],
                "list": [
                    {
                        "name": "Add Personality with Wall Decor",
                        "imgSrc": "",
                        products: [
                            tmsProductData.homeDecor.BrickPatternSelfAdhesiveWallpaper,
                            tmsProductData.homeDecor.ModernStencilsForWallPainting,
                            tmsProductData.homeDecor.PhotoFramesSet,
                            tmsProductData.homeDecor.WallSticker
                        ],
                        "description": [
                            {
                                "component": "recommendationsList",
                                "title": "Amazon Recommendations",
                                "recommendations": [
                                    {
                                        title: 'Wall Stickers',
                                        textWithLinks: `<< Random Wall Stickers with Floral Design(Pack of 2) | ${tmsProductData.homeDecor.BrickPatternSelfAdhesiveWallpaper.affiliateUrl} >> (₹189). These are easy to apply and remove.`
                                    },
                                    {
                                        title: 'Photo Frames Set',
                                        textWithLinks: `<< Set of 11 Black Photo Frames | ${tmsProductData.homeDecor.PhotoFramesSet.affiliateUrl} >> (₹749). Create a gallery wall with your favorite memories.`
                                    },
                                    {
                                        title: 'Peel-and-Stick Wallpaper',
                                        textWithLinks: `<< Brick Pattern Self-Adhesive Wallpaper | ${tmsProductData.homeDecor.BrickPatternSelfAdhesiveWallpaper.affiliateUrl} >> (₹149). Perfect for creating accent walls.`
                                    },
                                    {
                                        title: 'Wall design stencils',
                                        textWithLinks: `<< Modern Stencils for Wall Painting | ${tmsProductData.homeDecor.ModernStencilsForWallPainting.affiliateUrl} >> (₹178). Creative wall painting.`
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "component": "multiProductList",
                "paragraphs": [
                    "Use fairy lights or string lights for a cozy ambiance.",
                    "Add affordable table lamps or bedside lighting to elevate the mood."
                ],
                "list": [
                    {
                        "name": "Upgrade Your Lighting",
                        "imgSrc": "",
                        products: [
                            tmsProductData.homeDecor.FairyLights,
                            tmsProductData.homeDecor.TableLamps,
                            tmsProductData.homeDecor.LEDStripLights,
                            tmsProductData.homeDecor.ModernCeilingLamp
                        ],
                        "description": [
                            {
                                "component": "recommendationsList",
                                "title": "Amazon Recommendations",
                                "recommendations": [
                                    {
                                        title: 'Fairy Lights',
                                        textWithLinks: `<< LED String Lights with Remote Control  | ${tmsProductData.homeDecor.FairyLights.affiliateUrl} >> (₹499). Great for living rooms or bedrooms.`
                                    },
                                    {
                                        title: 'Table Lamps',
                                        textWithLinks: `<< Minimalist Bedside Lamp with Fabric Shade | ${tmsProductData.homeDecor.TableLamps.affiliateUrl} >> (₹399). Simple yet elegant.`
                                    },
                                    {
                                        title: 'LED Strip Lights',
                                        textWithLinks: `<< Smart LED Strip with App Control | ${tmsProductData.homeDecor.LEDStripLights.affiliateUrl} >> (₹1698). Add a modern touch to your space.`
                                    },
                                    {
                                        title: 'Modern Ceiling Lamp',
                                        textWithLinks: `<< Elegant ceiling lamp | ${tmsProductData.homeDecor.ModernCeilingLamp.affiliateUrl} >> (₹899). Enhance your living, bedroom.`
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },

            {
                "component": "multiProductList",
                "paragraphs": [
                    "Change up your curtains, cushion covers, or rugs to refresh your decor.",
                    "Layer throws and cushions for a cozy look."
                ],
                "list": [
                    {
                        "name": "Incorporate Affordable Textiles",
                        "imgSrc": "",
                        products: [
                            tmsProductData.homeDecor.CushionCovers,
                            tmsProductData.homeDecor.AreaRugs,
                            tmsProductData.homeDecor.Throws,
                            tmsProductData.homeDecor.FloralCurtains
                        ],
                        "description": [
                            {
                                "component": "recommendationsList",
                                "title": "Amazon Recommendations",
                                "recommendations": [
                                    {
                                        title: 'Fairy Lights',
                                        textWithLinks: `<< Set of 5 Printed Cotton Cushion Covers  | ${tmsProductData.homeDecor.CushionCovers.affiliateUrl} >> (₹499). Add pops of color to your sofa.`
                                    },
                                    {
                                        title: 'Table Lamps',
                                        textWithLinks: `<< Soft Shaggy Rug for Living Room | ${tmsProductData.homeDecor.AreaRugs.affiliateUrl} >> (₹1899). Simple yet elegant.`
                                    },
                                    {
                                        title: 'LED Strip Lights',
                                        textWithLinks: `<< Knitted Throw Blanket in Grey | ${tmsProductData.homeDecor.Throws.affiliateUrl} >> (₹459). Perfect for layering.`
                                    },
                                    {
                                        title: 'Modern Ceiling Lamp',
                                        textWithLinks: `<< Light-Filtering Cotton Curtains | ${tmsProductData.homeDecor.FloralCurtains.affiliateUrl} >> (₹1804). Enhanced Blackout & Illumination.`
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "component": "multiProductList",
                "paragraphs": [
                    "Add life to your space with indoor plants or artificial greenery.",
                    "Use stylish pots and planters for a modern look."
                ],
                "list": [
                    {
                        "name": "Use Indoor Plants and Greenery",
                        "imgSrc": "",
                        products: [
                            tmsProductData.homeDecor.ArtificialPlants,
                            tmsProductData.homeDecor.Planters,
                            tmsProductData.homeDecor.HangingPlanters,
                            tmsProductData.homeDecor.AirPurifyingPlants
                        ],
                        "description": [
                            {
                                "component": "recommendationsList",
                                "title": "Amazon Recommendations",
                                "recommendations": [
                                    {
                                        title: 'Artificial Plants',
                                        textWithLinks: `<< Set of 3 Small Artificial Succulents  | ${tmsProductData.homeDecor.ArtificialPlants.affiliateUrl} >> (₹450). Low-maintenance and trendy.`
                                    },
                                    {
                                        title: 'Planters',
                                        textWithLinks: `<< Ceramic Planters with Wooden Stand | ${tmsProductData.homeDecor.Planters.affiliateUrl} >> (₹1199). Adds a chic touch.`
                                    },
                                    {
                                        title: 'Hanging Planters',
                                        textWithLinks: `<< Macrame Hanging Plant Holder  | ${tmsProductData.homeDecor.HangingPlanters.affiliateUrl} >> (₹375). Great for vertical decor.`
                                    },
                                    {
                                        title: 'Air Purifying Plants',
                                        textWithLinks: `<< Indoor Oxygen Plants | ${tmsProductData.homeDecor.FloralCurtains.affiliateUrl} >> (₹999). Great for vertical decor.`
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "component": "multiProductList",
                "paragraphs": [
                    "Use candles, vases, and decorative trays to accessorize your space.",
                    "Opt for multi-functional decor items that are both beautiful and useful."
                ],
                "list": [
                    {
                        "name": "Enhance with Decorative Accessories",
                        "imgSrc": "",
                        products: [
                            tmsProductData.homeDecor.Candles,
                            tmsProductData.homeDecor.Vases,
                            tmsProductData.homeDecor.DecorativeTray,
                            tmsProductData.homeDecor.MiniatureSet
                        ],
                        "description": [
                            {
                                "component": "recommendationsList",
                                "title": "Amazon Recommendations",
                                "recommendations": [
                                    {
                                        title: 'Candles',
                                        textWithLinks: `<< Set of 3 Scented Candles in Glass Jars  | ${tmsProductData.homeDecor.Candles.affiliateUrl} >> (₹349). Adds fragrance and ambiance.`
                                    },
                                    {
                                        title: 'Vases',
                                        textWithLinks: `<< Minimalist Ceramic Vase Set | ${tmsProductData.homeDecor.Vases.affiliateUrl} >> (₹750). Perfect for fresh or artificial flowers.`
                                    },
                                    {
                                        title: 'Decorative Tray',
                                        textWithLinks: `<< Golden Metal Tray with Mirror Base  | ${tmsProductData.homeDecor.DecorativeTray.affiliateUrl} >> (₹664).Use it for organizing perfumes or trinkets.`
                                    },
                                    {
                                        title: 'Miniature Set',
                                        textWithLinks: `<< Use it for show pieces for home decor | ${tmsProductData.homeDecor.MiniatureSet.affiliateUrl} >> (₹369).Use it for show pieces for home decor..`
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
};